export const doNotTrackAnyExternAnchor = () => {
  for (const link of Array.from(document.links)) {
    if (link.hostname !== window.location.hostname) {
      link.target = '_blank'
      link.rel = 'noreferrer noopener'
    }
  }
}
